import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: '[app-ddtopnav]',
  standalone: true,
  imports: [],
  templateUrl: './ddtopnav.component.html',
  styleUrl: './ddtopnav.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class DdtopnavComponent {

}
